export const engagementCampaignIamClickDailyStatsCampaignId =
  "/engagement/campaign_iam_click_daily_stats/:campaign_id";
